import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"chevron-up\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M7 19c-.5.6-.5 1.4 0 2 .6.5 1.4.5 2 0l7-7.1 7 7a1.3 1.3 0 002.3-.9c0-.3-.1-.7-.4-1l-8-8c-.5-.5-1.3-.5-1.8 0l-8 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol